import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import React from "react";
import { Button } from "react-bootstrap";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import ChangeUsernameDialog from "./ChangeUsernameDialog";
import styles from "./SettingsUsernameRow.module.scss";

const SettingsUsernameRow: React.FC = () => {
    const [user, status] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    return (
        <>
            <ChangeUsernameDialog />
            <div className={styles.row}>
                <h4>Name</h4>
                {(!user || status === "loading") && "Loading..."}
                <p>
                    {user && (
                        <>
                            {user.username != null
                                ? user.username
                                : "No username set"}
                        </>
                    )}
                </p>
                <Button
                    data-toggle="modal"
                    data-target="#changeUsernameModal"
                    variant="primary"
                    size="sm"
                >
                    Change Name
                </Button>
            </div>
        </>
    );
};

export default SettingsUsernameRow;
